import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ColorScheme,
  ColorSchemeService,
} from '@fantaz/shared/services/color-scheme';

@Component({
  selector: 'fz-color-scheme-switcher',
  templateUrl: './color-scheme-switcher.component.html',
  styleUrls: ['./color-scheme-switcher.component.scss'],
})
export class ColorSchemeSwitcherComponent {
  @Input()
  userDarkIcon?: boolean;

  @Input()
  slideToggle?: boolean = false;
  @Output()
  toggleChange: EventEmitter<string> = new EventEmitter<string>();

  currentScheme: ColorScheme;

  constructor(private colorSchemeService: ColorSchemeService) {
    this.currentScheme = this.colorSchemeService.get();
  }

  setTheme() {
    this.currentScheme = this.toggleTheme;
    this.colorSchemeService.set(this.toggleTheme);
    this.toggleChange.emit(this.currentScheme);
  }

  get isDarkTheme() {
    return this.colorSchemeService.get() === ColorScheme.Dark;
  }

  get toggleTheme(): ColorScheme {
    return this.isDarkTheme ? ColorScheme.Light : ColorScheme.Dark;
  }
}
